import { ORGANIZATION_ID } from "./constants"
import { getJsonLdLanguage, type JsonLdNode } from "./core"

export interface NewsArticleOptions {
  /** 文章页 canonical URL */
  url: string
  /** 文章标题（不含站点后缀） */
  headline: string
  /** 页面级完整标题（含站点后缀），输出到 name */
  name?: string
  description?: string
  /** 封面/正文图片 URL 列表 */
  images?: string[]
  /** ISO8601 发布时间 */
  datePublished?: string
  /** ISO8601 修改时间；无独立修改时间时与 datePublished 相同 */
  dateModified?: string
  /** 关键词 */
  keywords?: string[]
  /** 栏目/板块名，如 ["Minor Metals", "Titanium"] */
  articleSection?: string[]
  inLanguage?: string
  organizationId?: string
  /** 自定义 author 节点（如第三方来源媒体）；未传时默认引用 Organization @id */
  author?: JsonLdNode
}

/** NewsArticle 节点。@id = canonical + #newsarticle。 */
export function buildNewsArticleJsonLd(options: NewsArticleOptions): JsonLdNode {
  const {
    url,
    headline,
    name,
    description,
    images,
    datePublished,
    dateModified,
    keywords,
    articleSection,
    inLanguage = "en",
    organizationId = ORGANIZATION_ID,
    author,
  } = options
  return {
    "@type": "NewsArticle",
    "@id": `${url}#newsarticle`,
    headline,
    ...(name ? { name } : {}),
    inLanguage: getJsonLdLanguage(inLanguage),
    author: author ?? { "@id": organizationId },
    publisher: { "@id": organizationId },
    ...(description ? { description } : {}),
    ...(images?.length ? { image: images } : {}),
    ...(datePublished ? { datePublished } : {}),
    ...(dateModified ? { dateModified } : {}),
    ...(keywords?.length ? { keywords: keywords.join(", ") } : {}),
    ...(articleSection?.length ? { articleSection } : {}),
  }
}
